export default "__VITE_ASSET__UgyFOxev__"